<template>
  <modal v-bind="modalParams" @modalClick="cancel">
    <transition name="popup">
      <div v-show="isShow" class="date-time">
        <div class="date-time-header">
          <p class="cancel" @click="cancel">
            {{ $t('cancelBtnText') }}
          </p>
          <p class="title">
            {{ title }}
          </p>
          <p class="completed" @click="completed">
            {{ $t('completedText') }}
          </p>
        </div>
        <div class="date-time-content">
          <Picker class="date-time-item" v-bind="years" @onChange="setDate($event, 'year')" />
          <Picker class="date-time-item" v-bind="months" @onChange="setDate($event, 'month')" />
          <Picker class="date-time-item" v-bind="dates" @onChange="setDate($event, 'date')" />
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
import Modal from '../Modal'
import Picker from '../Picker'
import i18nSetting from '@/utils/languageSet'
import LangConfig from '@/locale/export/dateTime.js'
import moment from '@/utils/moment'
import { showToast } from '@/utils/nativeBridge.js'
import utils from '@/utils/utils'
const $i18n = i18nSetting(LangConfig)
const { getYMD, fmMDY } = moment
export default {
  components: {
    Modal,
    Picker
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: false,
      isShow: false,
      maxDate: '',
      minDate: '',
      errorText: '',
      callback: null,
      years: {
        data: [],
        selectedIndex: -1
      },
      months: {
        data: [],
        selectedIndex: -1
      },
      dates: {
        data: [],
        selectedIndex: -1
      },
      year: '',
      month: '',
      date: '',
      modalParams: {
        showModal: false,
        lockScroll: true
      }
    }
  },
  watch: {
    value (newVal) {
      this.modalParams.showModal = newVal
      this.isShow = newVal
      const { year, month, date } = getYMD(this.date)
      this.year = year
      this.month = month
      this.date = date
      this.getYears()
      this.getMonths()
      this.getDates()
    }
  },
  created () {
    this.getLang()
    this.initLables()
  },
  methods: {
    getLang () {
      this.lang = utils.getQueryString('lang')
    },
    formatMonth (num) {
      const map = ['January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      return map[num - 1]
    },
    setDate (data, key) {
      const { value } = data
      this[key] = value
      this.getDates()
    },
    getYears () {
      this.years.data = []
      for (let i = 1900; i <= 2030; i++) {
        if (i === this.year) {
          this.years.selectedIndex = i - 1900
        }
        this.years.data.push({
          value: i,
          text: this.lang === 'en-US' ? `Year ${i}` : `${i}${this.$t('year')}`
        })
      }
    },
    getMonths () {
      this.months.data = []
      for (let i = 1; i <= 12; i++) {
        if (i === this.month) {
          this.months.selectedIndex = i - 1
        }
        this.months.data.push({
          value: i,
          text: this.lang === 'en-US' ? this.formatMonth(i) : `${i}${this.$t('month')}`
        })
      }
    },
    getDates () {
      this.dates.data = []
      const days = new Date(this.year, this.month, 0).getDate()
      if (this.date > days) {
        this.date = days
      }
      for (let i = 1; i <= days; i++) {
        if (i === this.date) {
          this.dates.selectedIndex = i - 1
        }
        this.dates.data.push({
          value: i,
          text: this.lang === 'en-US' ? `${i}` : `${i}${this.$t('date')}`
        })
      }
    },
    cancel () {
      this.isShow = false
      setTimeout(() => {
        this.modalParams.showModal = false
        this.value = false
      }, 300)
    },
    completed () {
      const selectDate = `${this.year}/${this.month}/${this.date}`
      const selectTime = new Date(selectDate).getTime()
      const maxTime = new Date(this.maxDate).getTime()
      const minTime = new Date(this.minDate).getTime()
      // 开始日期不得超过结束日期，但是可以选择当天
      if ((this.maxDate && selectTime > maxTime) ||
        (this.minDate && selectTime < minTime)) {
        showToast(this.errorText, 1)
        return
      }
      this.callback({
        action: 'completed',
        date: fmMDY(selectDate)
      })
      this.cancel()
    },
    initLables () {
      Object.defineProperty(this, '$t', {
        value: this.$t.bind({ $i18n }),
        enumerable: false,
        configurable: true,
        writable: true
      })
    },
    closeMask () {
      this.isShow = false
      this.modalParams.showModal = false
      this.value = false
    }
  }
}
</script>
<style lang="scss" scoped>
.date-time {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: $color-bg-white;
  .date-time-header {
    @include border-bottom;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 15px 20px;
    p {
      flex: 1;
      color: $color-text;
      font-size: $span-font-size;
      line-height: 14px;
      text-align: center;
    }
    p.cancel {
      font-size: $base-font-size;
      line-height: 16px;
      text-align: left;
    }
    p.completed {
      color: $color-primary;
      font-size: $base-font-size;
      line-height: 16px;
      text-align: right;
    }
  }
  .date-time-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 206px;
    .date-time-item {
      flex: 1;
    }
  }
}
.popup-enter-active {
  animation: slide-in 0.3s ease;
}
.popup-leave-active {
  animation: slide-out 0.3s ease;
}
@keyframes slide-in {
  0% {
    margin-bottom: -100%;
  }
  100% {
    margin-bottom: 0;
  }
}
@keyframes slide-out {
  0% {
    margin-bottom: 0;
  }
  100% {
    margin-bottom: -100%;
  }
}
</style>
